import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LANDING_1_PRICING_TIERS } from "../../landing-1.section-data";

@Component({
  selector: "app-landing-1-pricing",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./landing-1-pricing.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1PricingComponent {
  readonly dashboardUrl = input.required<string>();
  readonly pricingTiers = LANDING_1_PRICING_TIERS;
}
